import React, {useContext , useRef , useEffect , useState ,useLayoutEffect } from 'react'
import ProgresbarHead from './ProgresbarHead'
import  DataFetch  from '../../Context/DataFetch'
import moment from 'moment';
import Language from '../../Context/Language'

export default function LastMatches() {
      const {HomeLastMatchData} =  useContext(DataFetch);
      const {AwayLastMatchData} = useContext(DataFetch);
      const {data} = useContext(DataFetch);
      const dataLang = useContext(Language)

      const ref = useRef(null);
          const changeBackground=(a) => e => {
            if(e.target.offsetWidth < e.target.scrollWidth) {
              e.target.setAttribute('data-tooltip', a);
            }
            else{
              
            }
      
          }
      

  return (
    <div className='LastMatchContainer'>
        <div className='LastMatchHeader'>
            <div className='LastMatchHeaderText'>{dataLang[sessionStorage.getItem("lang")].LastMatches}</div>
        </div>
        <div className='LastMatchArea'>
          <div className='LastMatchHomeArea'>
            <div className='LastMatchHomeDiv'>
            <div className='LastMatchHomeHeader'>
                 <div className='LastMatchDate'>{dataLang[sessionStorage.getItem("lang")].Date}</div>
                 <div className='LastMatchShow'>{dataLang[sessionStorage.getItem("lang")].Match}</div>
                 <div className='LastMatchTournament'>{dataLang[sessionStorage.getItem("lang")].Tournament}</div>
             </div>
           

      {    
      HomeLastMatchData.length !== 0 ?
               HomeLastMatchData.map(function(item, i){
                       return  <div key={i} className='LastMatchHomeTable'>
                  <div className='LastMatchDate'>{moment(item.start_Time).format("DD/MM/YY")}</div>
                  <div className='LastMatchShow'>
                     <div className='LastMatchShowHomeTeam'>
                           <div className='LastMatchTeam selectedLast'>{item.home_Team_Name}</div>
                           <div className='lastMatchScore' id={ (item.home_Team_Id === data.homeTeamId && item.winner_Id === data.homeTeamId) ? "lastwin"  :(item.home_Team_Id === data.homeTeamId && item.winner_Id !== 0 && item.winner_Id !== data.homeTeamId) ? "lostwin" :  ""}>{item.home_Score}</div>
                     </div>
                     <div className='HomeLastMatchShowMatchSpan'>-</div>
                     <div className='LastMatchShowAwayTeam'>
                           <div className='lastMatchScore' id={ (item.away_Team_Id === data.homeTeamId && item.winner_Id === data.homeTeamId) ? "lastwin"  :(item.away_Team_Id === data.homeTeamId && item.winner_Id !== 0 && item.winner_Id !== data.homeTeamId) ? "lostwin" :  ""} >{item.away_Score}</div>
                           <div className='LastMatchTeam'>{item.away_Team_Name}</div>
                     </div>
                  </div>
                  <div  onMouseOver={changeBackground(item.competitionName)}  className="tooltip LastMatchTournament" ><div className="BeetweenMatchTextTool">{item.competitionName}</div></div>
                  </div>

               })

               :
               ""
      }

            </div>
           
          </div>
          <div className='LastMatchAwayArea'>
            <div className='LastMatchAwayDiv'>
            <div className='LastMatchHomeHeader'>
                 <div className='LastMatchDate'>{dataLang[sessionStorage.getItem("lang")].Date}</div>
                 <div className='LastMatchShow'>{dataLang[sessionStorage.getItem("lang")].Match}</div>
                 <div className='LastMatchTournament'>{dataLang[sessionStorage.getItem("lang")].Tournament}</div>
             </div>

             {
                  AwayLastMatchData.length !==0 ?
                     AwayLastMatchData.map(function(item, i){
                                    return     <div key={i} className='LastMatchHomeTable'>
                                    <div className='LastMatchDate'>{moment(item.start_Time).format("DD/MM/YY")}</div>
                                    <div className='LastMatchShow'>
                                       <div className='LastMatchShowHomeTeam'>
                                             <div className='LastMatchTeam selectedLast'>{item.home_Team_Name}</div>
                                             <div className='lastMatchScore' id={ (item.home_Team_Id === data.awayTeamId && item.winner_Id === data.awayTeamId) ? "lastwin"  :(item.home_Team_Id === data.awayTeamId && item.winner_Id !== 0 && item.winner_Id !== data.awayTeamId) ? "lostwin" :  ""}>{item.home_Score}</div>
                                       </div>
                                       <div className='HomeLastMatchShowMatchSpan'>-</div>
                                       <div className='LastMatchShowAwayTeam'>
                                             <div className='lastMatchScore' id={ (item.away_Team_Id === data.awayTeamId && item.winner_Id === data.awayTeamId) ? "lastwin"  :(item.away_Team_Id === data.awayTeamId && item.winner_Id !== 0 && item.winner_Id !== data.awayTeamId) ? "lostwin" :  ""}>{item.away_Score}</div>
                                             <div className='LastMatchTeam'>{item.away_Team_Name}</div>
                                       </div>
                                    </div>
                                    <div onMouseOver={changeBackground(item.competitionName)}  className="tooltip LastMatchTournament" ><div className="BeetweenMatchTextTool" >{item.competitionName}</div></div>
                                    </div>
                     })

                     :
                     ""
             }
         

            </div>
         
          </div>
        </div>
    </div>
  )
}
